import axios from 'axios';
import { API_GET_PARAMETERS } from '../../constants'

export default {
  state: {
    parameters: []
  },
  mutations: {
    SET_PARAMETERS: (state, payload) => {
      state.parameters = payload;
    }
  },
  actions: {
    FETCH_PARAMETERS: async (context, payload) => {
      let parametersResponse = await axios.get(API_GET_PARAMETERS(payload.domain));
      const parameters = parametersResponse.data.result.data;
      context.commit('SET_PARAMETERS', parameters);
      return parameters;
    }
  },
  getters: {
    PARAMETERS: state => {
      return state.parameters;
    },
    PARAMETER_BY_ID(state) {
      return userId => {
        return state.parameters.find(user => user.id === userId)
      }
    }
  }
}